import { useContext, useEffect, useState } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import useSWR from 'swr';

import { fetchEnrolledStudents } from '../../lib/Students';
import { AppProvider } from '../../context/AppProvider';

import { Student } from '../../types/Student';

import SharedPagination from '../Shared/SharedPagination';
import SubmissionWrapper from '../Shared/SubmissionWrapper';
import PerPageDropDown from '../Shared/SharedPagination/PerPageDropdown';
import SubmissionCard from '../Shared/SubmissionCard';
import SubmissionSkeleton from '../Shared/SubmissionSkeleton';
import VideoPopup from '../Shared/VideoPopup';

const SubmissionMasteryBank = ({ page, setPerPage, setPage, perPage }: { page: number; setPerPage: React.Dispatch<React.SetStateAction<number>>; setPage: React.Dispatch<React.SetStateAction<number>>; perPage: number }) => {
  const { token, mbTitle, videoButtonLable, videoUrl, fileLinkLabel, fileLink } = useContext(AppProvider);
  const [totalPages, setTotalPages] = useState(0);

  const { data: studentList, mutate, error, isLoading } = useSWR(['/wp-json/wall-of-fame/v1/submissions', token, page, perPage], ([path, token, page, perPage]) => fetchEnrolledStudents(path, token, 'mastery_bank_2024', page, perPage), { revalidateOnFocus: false });

  useEffect(() => {
    setTotalPages(Math.ceil((studentList?.total || 0) / perPage));
  }, [studentList, perPage]);

  if (error) {
    return <p>error...</p>;
  }

  if (isLoading) {
    return <SubmissionSkeleton perPage={perPage} hideElement={true} />;
  }

  return (
    <SubmissionWrapper
      paginationComponent={<SharedPagination page={page} setPage={setPage} totalPages={totalPages} />}
      perPageDropDownComponent={<PerPageDropDown perPage={perPage} setPage={setPage} setPerPage={setPerPage} />}
      title={
        <>
          <div className='video-outer-box px-10 flex justify-center gap-4 items-center mb-6'>
            <VideoPopup label={videoButtonLable} url={videoUrl} />
            <a href={fileLink} target='_blank' className='button underline hover:text-blue-800'>
              {fileLinkLabel}
            </a>
          </div>
          <h2 className='font-semibold mb-6 text-center px-10'>{mbTitle}</h2>
        </>
      }
    >
      {studentList?.data ? (
        studentList?.data?.map((student: Student, index: number) => <SubmissionCard user={student} key={index} token={token} mutate={mutate} dropDown={false} addStudentButton={false} />)
      ) : (
        <p className='text-center text-gray-500 absolute flex left-0 justify-center w-full items-center min-h-80'>No students are currently enrolled for the Wall of Fame.</p>
      )}
    </SubmissionWrapper>
  );
};

export default SubmissionMasteryBank;
